<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <transition 
        name="fade" 
        mode="out-in"
        @before-leave="onTransitionStart"
        @after-enter="onTransitionEnd"
      >
        <component :is="Component" :key="$route.fullPath" />
      </transition>
    </router-view>
    <!-- Halaman publik pelanggan tidak menawarkan instal aplikasi staf -->
    <InstallPrompt v-if="!$route.meta.public" />
    <!-- Popup versi baru hanya untuk staf; halaman pelanggan (cek member, feedback) tanpa popup -->
    <PWAUpdatePopUp v-if="$route.matched.length && !$route.meta.public && !$route.meta.hideNav" />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from './stores/auth'
import InstallPrompt from './components/InstallPrompt.vue'
import PWAUpdatePopUp from './components/PWAUpdatePopUp.vue'

// Import router
const router = useRouter()
const authStore = useAuthStore()

// Debug Lifecycle
onMounted(() => {
  console.log('🔄 App Mounted')
  window.addEventListener('unhandledrejection', handleUnhandledRejection)
})

onUnmounted(() => {
  console.log('🧹 App Unmounted')
  console.log('🔄 App mounted, initializing auth...')
  const hasSession = authStore.initializeFromStorage()
  console.log('Auth initialization result:', {
    hasSession,
    isAuthenticated: authStore.isAuthenticated,
    currentRoute: router.currentRoute.value.path
  })
  window.removeEventListener('unhandledrejection', handleUnhandledRejection)
})

// Transition Handlers
const onTransitionStart = () => {
  console.log('↗️ Layout transition started:', {
    route: router.currentRoute.value.path,
    layout: router.currentRoute.value.meta?.layout || 'none'
  })
}

const onTransitionEnd = () => {
  console.log('✅ Layout transition completed:', {
    route: router.currentRoute.value.path,
    layout: router.currentRoute.value.meta?.layout || 'none'
  })
}

// Error Handling
const handleUnhandledRejection = (event) => {
  console.error('🚨 Unhandled Promise Rejection:', event.reason)
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>